import React from 'react';

import { InferPushQueueItem } from 'Libs/queue/redux/utils';
import { isFeatureEnabled } from 'Services/feature-flags';
import { Language } from 'Services/language/languageService';
import AudienceGroupList from 'Features/audience/pages/AudienceGroupList/AudienceGroupList';

import { MkQueueHandler } from 'Pages/Courses/utils/edition-handlers';
import { TabsEnum } from 'Pages/Courses/types';
import { type CourseEdited, useModuleSelector } from 'Pages/Courses/redux';
import { useAICourseEditionTabs } from 'Pages/Courses/Edition/hooks/useAICourseEditionTabs';
import { useAudienceGroupListProps } from 'Pages/Courses/Edition/hooks/useAudienceGroupListProps';
import ViewManager from 'Pages/Courses/Edition/views/ViewManager/ViewManager';
import styles from './TabsContainer.style';

type AICourseEditionTabsContainerProps = {
  push: (item: InferPushQueueItem<MkQueueHandler>) => void;
  audienceLanguages: Language[];
};

export const AICourseEditionTabsContainer: React.FC<AICourseEditionTabsContainerProps> = ({
  push,
  audienceLanguages,
}) => {
  const canSeeAudience = isFeatureEnabled('course-audience');

  const { currentTabIndex } = useAICourseEditionTabs();

  const { audienceGroupListProps } = useAudienceGroupListProps();

  const course: CourseEdited | undefined = useModuleSelector((state) => state.edition.course);
  const groupIds = useModuleSelector((state) => state.edition.groupIds);

  return (
    <div id="tab-container-wrapper" style={styles.wrapper}>
      {currentTabIndex === TabsEnum.CONTENT && (
        <div id="content-wrapper" style={styles.contentWrapper}>
          <ViewManager push={push} course={course} />
        </div>
      )}
      {
        /* TAB DISPLAY */
        currentTabIndex === TabsEnum.AUDIENCE && canSeeAudience && course && (
          <AudienceGroupList
            entityId={course?.id || -1}
            assignedAudienceGroupIds={groupIds}
            languages={audienceLanguages}
            {...audienceGroupListProps}
          />
        )
      }
    </div>
  );
};

export default AICourseEditionTabsContainer;
